import { retrieveUser } from "../api/retrieveUser.js";

/**
 * Retrieve the user from the backend.  If the user has
 * been disabled, return will be {}
 * @param {} param0
 * @returns
 */
export default async function userLoader({ params }) {
  //TODO: Probably don't need this line anymore....
  //const username = params.username === 'interiordesignerella1'? 'interiordesignerella' : params.username;
  const username = params.username;

  const dirtyUser = await retrieveUser(username.toLowerCase());

  console.log(dirtyUser);
  if (dirtyUser === "{}") {
    return undefined;
  } else {
    const dirtyUserButtonList = dirtyUser.data.Item.userButtonList;
    const cleanUserButtonList = dirtyUserButtonList.map((item) => {
      return {
        buttonId: item.SK.S,
        url: item.url.S,
        text: item.text.S,
        order: parseInt(item.order.N, 10),
      };
    });

    const profilePicObjectKey = dirtyUser.data.Item.profilePicObjectKey;
    const welcome = dirtyUser.data.Item.welcome || "";
    const profilePicUrl =
      profilePicObjectKey !== undefined
        ? `https://${process.env.REACT_APP_DOMAIN}/${profilePicObjectKey}`
        : undefined;

    // Empty string means the user has no background (or removed it).
    const backgroundImageObjectKey = dirtyUser.data.Item.backgroundImageObjectKey;
    const backgroundImageUrl = backgroundImageObjectKey
      ? `https://${process.env.REACT_APP_DOMAIN}/${backgroundImageObjectKey}`
      : undefined;

    // Only a strict #rrggbb reaches the page style; empty or anything else means the default.
    const rawBackgroundColor = dirtyUser.data.Item.backgroundColor;
    const backgroundColor = /^#[0-9a-fA-F]{6}$/.test(rawBackgroundColor || "")
      ? rawBackgroundColor
      : undefined;

    const cleanUser = {
      userButtonList: cleanUserButtonList,
      userId: dirtyUser.data.Item.PK,
      username: dirtyUser.data.Item.username || "",
      profilePicUrl: profilePicUrl,
      backgroundImageUrl: backgroundImageUrl,
      backgroundColor: backgroundColor,
      welcome: welcome,
      profilePageDisclosure: dirtyUser.data.Item.profilePageDisclosure || "",
      subImageLinksAction: dirtyUser.data.Item.subImageLinksAction || "",
      subImageLinksDisclosure:
      dirtyUser.data.Item.subImageLinksDisclosure || "",
      fbEnabled: dirtyUser.data.Item.igStatus === "enabled",
      tiktokEnabled: dirtyUser.data.Item.tiktokStatus === "enabled",
      metaPixelId: dirtyUser.data.Item.metaPixelId,
      base_subscription: dirtyUser.data.Item.base_subscription,
      igAspectRatio: dirtyUser.data.Item.igAspectRatio,
      metaPixelAllowed: dirtyUser.data.Item.metaPixelAllowed || false
    };
    return cleanUser;
  }
}
